export interface BarListItem {
  key: string | number
  /** Fx meldingsnavn eller trumffarve, med antal i parentes. */
  label: string
  /** 0-100. Styrer både bjælkens bredde og farve-tærsklen. */
  value: number
  /** Færdigformateret tekst til højre, fx "72 %". */
  valueLabel: string
  /** Ekstra detalje til hover/skærmlæser, fx "8 af 11 vundet". */
  detail?: string
}

interface BarListProps {
  items: BarListItem[]
  ariaLabel: string
}

function colorClass(value: number): string {
  if (value >= 60) return 'bg-mint'
  if (value >= 35) return 'bg-gold'
  return 'bg-red'
}

/** Horisontale bjælker, farvet mint/gold/red efter tærskel. Til meldinger og trumf. */
function BarList({ items, ariaLabel }: BarListProps) {
  return (
    <div className="grid gap-2" role="img" aria-label={ariaLabel}>
      {items.map((item) => (
        <div
          key={item.key}
          className="grid grid-cols-[92px_1fr_44px] items-center gap-2 text-[0.78rem]"
          title={item.detail}
        >
          <span className="min-w-0 truncate text-text-2">{item.label}</span>
          <div className="h-3 overflow-hidden rounded-full bg-ink/30">
            <div
              className={`h-full rounded-full ${colorClass(item.value)}`}
              style={{ width: `${Math.max(0, Math.min(100, item.value))}%` }}
            />
          </div>
          <span className="text-right font-mono">{item.valueLabel}</span>
        </div>
      ))}
    </div>
  )
}

export default BarList
